import { useState } from "react"
import CardHeader from "../../../Components/Card/CardHeader"
import Dropdown from "../../../Components/Dropdown/Dropdown"
import RequestFooter from "../../../Components/RequestFooter/RequestFooter"
import styles from "./request.result.module.css"
import SmallCard from "../../../Components/SmallCard/SmallCard"
import folderIcon from "../../../icons/folderIcon.svg"
import Modal from "../../../Components/Modal/Modal"
import fileIcon from "../../../icons/PdfIcon.svg"
import { useOutletContext } from "react-router-dom"
import useRequestContext from "../useRequestContext"
import Badge from "../../../Components/Badge/Badge"
import Button from "../../../Components/Button/Button"
import CardContainer from "../../../Components/Card/CardContainer"
import CardBody from "../../../Components/Card/CardBody"

export default function RequestResult() {
    const [isShow, setShow] = useState(true)
    const [isModal, setModal] = useState(false)
    const { request, id, status } = useRequestContext()
    return (
        <div className={styles.container}>
            <div className={styles.info_container}>
                <div className={styles.info_body}>
                    <div className={styles.info_item}>
                        <span className={styles.info_key}>Статус заявки</span>
                        <div className={styles.info_value}>
                            <Badge type={status.style} text={status.name}></Badge>
                        </div>
                    </div>
                    <div className={styles.info_item}>
                        <span className={styles.info_key}>Номер заявки в Росреестре</span>
                        <div className={styles.info_value}>
                            {
                                status?.code >= 5 &&
                                <span>{request?.Rosreestr?.RegistryNumber}</span>
                            }

                        </div>
                    </div>
                    <div className={styles.info_item}>
                        <span className={styles.info_key}>Номер записи КУВД</span>
                        <div className={styles.info_value}>

                            {
                                status?.code == 5 &&
                                <span>{request?.Rosreestr?.Kuvd}</span>
                            }
                        </div>
                    </div>
                    <div className={styles.info_item}>
                        <span className={styles.info_key}>Сообщение из Росреестра</span>
                        <div className={styles.info_value}>
                            <span>{request?.Rosreestr?.RegistryMessage}</span>
                        </div>
                    </div>
                    <div className={styles.info_item}>
                        <span className={styles.info_key}>УИН для оплаты</span>
                        <div className={styles.info_value}>
                            <span>
                                {request?.Rosreestr.Uins[0] &&
                                    <a target="_blank" href={`https://payment.gosuslugi.ru/?billNumber=${request?.Rosreestr.Uins[0]}`}>УИН = {request?.Rosreestr.Uins[0]} оплатить</a>
                                }
                            </span>
                        </div>
                    </div>


                    <div className={styles.info_item}>
                        <span className={styles.info_key}>Документы</span>
                        <div className={styles.info_value}>
                            <span></span>
                        </div>
                    </div>
                    {/* {request?.Rosreestr.Documents.map((x) =>
                        <div className={styles.info_item}>
                            <span className={styles.info_key}></span>
                            <div className={styles.info_value}>
                                <span>{x.FileName}</span>
                            </div>
                        </div>
                    )
                    } */}

                    <Dropdown onClick={() => setShow(!isShow)} isShown={isShow} title="Информация по заявке" >

                        <div className={styles.info_item}>
                            <span className={styles.info_key}>Название заявки</span>
                            <div className={styles.info_value}>
                                <span>{`${request?.RegAction.name} #${request?.Number}`}</span>
                            </div>
                        </div>
                        <div className={styles.info_item}>
                            <span className={styles.info_key}>Дата создания заявки</span>
                            <div className={styles.info_value}>
                                <span>{request?.DateCreate}</span>
                            </div>
                        </div>
                        <div className={styles.info_item}>
                            <span className={styles.info_key}>Создатель заявки</span>
                            <div className={styles.info_value}>
                                <span>{request?.User.name}</span>
                            </div>
                        </div>
                        <div className={styles.info_item}>
                            <span className={styles.info_key}>Объект</span>
                            <div className={styles.info_value}>
                                <span>{request?.Object.Address.Note}</span>
                            </div>
                        </div>
                        <div className={styles.info_item}>
                            <span className={styles.info_key}>Участники</span>
                            <div className={styles.info_value}>
                                <span>Писцов Кирилл Валентинович, Иванова Ирина Владимировна</span>
                            </div>
                        </div>

                    </Dropdown>

                </div>

            </div>
            {status.code === 5 &&
                <CardContainer>
                    <CardHeader title="Результат регистрации в Росреестре"></CardHeader>
                    <CardBody >
                        <SmallCard avatar={folderIcon} onSelect={() => setModal(true)} type="default" title="Результаты регистрации" subtitle="Папка со всеми результатами из Росреестра" />
                        <SmallCard avatar={folderIcon} onSelect={() => setModal(true)} type="default" title="Папка со всеми документами, отправленными в Росреестр" subtitle="Папка со всеми документами, отправленными в Росреестр" />
                        <SmallCard avatar={folderIcon} onSelect={() => setModal(true)} type="default" title="Сгенерированное заявление на регистрацию №С20210514.pdf" subtitle="Заявление о государственной регистрации права, ограничения (обременения) права на недвижимое имущество, сделки с недвижимым имуществом, государственной регистрации законного владельца закладной" />
                    </CardBody>
                </CardContainer>
            }

            <RequestFooter back={<Button href={`/request/signature/${request?.Id}`} text="Назад"></Button>}></RequestFooter>
            <Modal title="Файлы" isOpen={isModal} setOpen={setModal}>
                <SmallCard avatar={fileIcon} type="default" title="Право собственности.pdf" subtitle=""></SmallCard>
            </Modal>
        </div>)
}